import { useEffect, useRef } from 'react';
/** Returns the previous value when it changes */
export const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
};
//# sourceMappingURL=usePrevious.js.map